module.exports = __webpack_public_path__ + "static/img/bonus_5.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_5.png
// module id = +GP5
// module chunks = 0